import httpClient from './httpClient'

export default {
  CustomerActivity: {
    Create(payload) {
      return httpClient.post('CustomerActivity/Create', payload)
    },
    GetCustomerActivities(payload) {
      return httpClient.post('CustomerActivity/GetCustomerActivities', payload)
    },
    GetActionTypes(payload) {
      return httpClient.post('CustomerActivity/GetActionTypes', payload)
    },
    ExportCsv(payload) {
      return httpClient.post('CustomerActivity/ExportCsv', payload, {
        responseType: 'blob',
      })
    },
  },
}
